<template>
	<div class="main-page">
		<SiteIntro heading :text="false" />
		<!-- 청구할인 혜택 정리 바로가기. 프로필 benefitGuide 호스트(bridgem·kb·nhbank·samsung·woori·geps)만. 심의 문구 호스트(kbprm·narasarang)는 없음 -->
		<RouterLink v-if="showBenefitGuide" to="/HFO_HI_002" class="card_benefit_float">
			청구할인<br />혜택 정리
		</RouterLink>
		<!-- 메인 팝업 (PC 레이어 팝업) -->
		<MainPopup v-if="!isMobile" :images="popupImages" @click="handleMainPopupClick" />

		<!-- 모바일 하단 팝업 -->
		<MobileBanner v-if="isMobile && showMobileBanner && mobileBanners.length > 0"
			:banner="mobileBanners[currentMobileBannerIndex]" @close="showMobileBanner = false"
			@click="handleMobileBannerClick" @notToday="handleMobileBannerNotToday" />

		<!-- 상단 slide -->
		<div class="main_visual_area">
			<div v-if="heroBanners && heroBanners.length > 0">
				<swiper :key="heroSwiperKey" :modules="modules" class="main-visual-swiper" :loop="true"
					:effect="visualEffect" :observer="true" :observeParents="true" :creativeEffect="{
						limitProgress: 2,
						prev: {
							translate: ['-106%', 0, -1],
							opacity: 0.55,
							scale: 1,
						},
						next: {
							translate: ['106%', 0, -1],
							opacity: 0.78,
							scale: 1,
						},
					}" :speed="900" :autoplay="{
						delay: 4500,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
					}" :navigation="{
						nextEl: '.top_visual_next',
						prevEl: '.top_visual_prev',
					}" :breakpoints="heroVisualBreakpoints" @swiper="onSwiperInit">
					<swiper-slide v-for="(item, index) in heroBanners" :key="index">
						<div class="hero-img-wrap">
							<!-- 브랜드 연결 배너 -->
							<a v-if="item.brandUuid" :href="'/HFO_BI_002/' + item.brandUuid" @click.prevent="handleLinkClick(item)" :target="_self"
								rel="noopener noreferrer">
								<picture>
									<source media="(max-width: 1023px)" :srcset="makeBannerImageUrl(item.bannerPathMo || item.bannerPath)" />
									<img :src="makeBannerImageUrl(item.bannerPath)" :alt="item.bannerTitle || '히어로 배너'"
										:loading="index === 0 ? 'eager' : 'lazy'" :fetchpriority="index === 0 ? 'high' : 'auto'"
										@error="handleBannerHeroPcImageError" />
								</picture>
							</a>

							<!-- URL 연결 배너 -->
							<a v-else href="#" @click.prevent="handleLinkClick(item)" rel="noopener noreferrer">
								<picture>
									<source media="(max-width: 1023px)" :srcset="makeBannerImageUrl(item.bannerPathMo || item.bannerPath)" />
									<img :src="makeBannerImageUrl(item.bannerPath)" :alt="item.bannerTitle || '히어로 배너'"
										:loading="index === 0 ? 'eager' : 'lazy'" :fetchpriority="index === 0 ? 'high' : 'auto'"
										@error="handleBannerHeroPcImageError" />
								</picture>
							</a>

							<!-- per-slide CSS-only navigation buttons (visible only on active slide) -->
							<button type="button" class="hero-btn hero-prev" @click.stop.prevent="onHeroPrev"
								aria-label="이전 배너">‹</button>
							<button type="button" class="hero-btn hero-next" @click.stop.prevent="onHeroNext"
								aria-label="다음 배너">›</button>
						</div>
					</swiper-slide>
				</swiper>

				<div class="top_visual_btn">
					<button type="button" class="top_visual_prev">이전</button>
					<button type="button" class="top_visual_next">다음</button>
				</div>
			</div>
		</div>
		<!-- //상단 slide -->

		<div class="cont_center" :class="{ 'samsung-hide': isSamsungHost }">
			<!-- 검색어 배너 -->
			<div v-if="isNarasarangOrigin" class="narasarang-banner-wrapper">
				<a href="https://www.narasarang.or.kr/" target="_blank" rel="noopener noreferrer">
					<img :src="narasarangLogo" alt="Nara Sarang" class="narasarang-logo" loading="lazy" />
				</a>
			</div>
			<div class="banner_brand_area">
				<RouterLink to="/HFO_HI_001">
					<!-- <span class="orange">하이비타민, 복지카드로 상시 청구할인</span>
					<span class="orange"></span> 받고 매달 달라지는<br class="pc_none" />
					<span class="green"> 브랜드 혜택을</span> 즐기세요. -->
					<span class="green">브랜드별로 </span>
					<span>혜택 적용 매장이 상이할 수 있습니다. 방문 전 </span>
					<span class="orange">[매장검색] </span>
					<span>메뉴에서 매장을 확인해 주세요.</span>
					<span class="view">view</span>
				</RouterLink>

				<!-- 열렸을때 open 클래스 추가 -->
				<div :class="['search_word_area', { open: isOpen }]" v-if="searchBanners && searchBanners.length > 0">
					<div class="search-word-header">
						<!-- 첫 번째 검색어를 버튼으로 표시 (클릭 시 해당 브랜드로 이동) -->
						<div class="keyword-container" v-if="searchBanners[0]">
							<span class="hot-label">HOT</span>
							<span class="keyword-text" @click="navigateToSearchBrand(searchBanners[0])">
								{{ searchBanners[0].bannerTitle }}
							</span>
							<!-- 화살표 버튼만 분리 -->
							<button type="button" class="toggle-btn" @click="toggleOpen"></button>
						</div>
					</div>

					<!-- 나머지 검색어를 목록으로 표시 -->
					<ul class="search_word_list" v-if="isOpen">
						<li v-for="(banner, index) in searchBanners.slice(1)" :key="index"
							@click="navigateToSearchBrand(banner)" class="clickable-search-item">
							{{ banner.bannerTitle }}
						</li>
					</ul>
				</div>
			</div>
			<!-- //검색어 배너 -->

			<!-- 신규 브랜드 -->
			<div class="new_brand_area">
				<h2 class="title_main">신규 브랜드</h2>

				<div class="new_brand_swiper">
					<swiper :modules="modules" :slides-per-view="slidesPerView" :space-between="spaceBetween"
						:loop="true" :loopFillGroupWithBlank="false" :watchSlidesProgress="true"
						:watchSlidesVisibility="true" :observer="true" :observeParents="true" :initialSlide="0"
						:speed="900" :autoplay="{
							delay: 7000,
							disableOnInteraction: false,
							pauseOnMouseEnter: true,
						}" :pagination="{
							el: '.new_brand_paging',
							clickable: true,
							dynamicBullets: false,
							type: 'bullets'
						}" :breakpoints="swiperBreakpoints" @swiper="onNewBrandSwiperInit" @slideChange="onNewBrandSlideChange"
						@transitionEnd="onNewBrandTransitionEnd">
						<swiper-slide v-for="(item, index) in newBanners" :key="index">
							<!-- 브랜드 클릭 시 팝업 열기로 변경 -->
							<a href="#" @click.prevent="openBrandPopup(item)" rel="noopener noreferrer">
								<img :src="makeBannerImageUrl(item.bannerPath)" :alt="item.bannerTitle || '신규 브랜드 배너'"
									@error="handleBannerBrandImageError" loading="lazy" />
							</a>
						</swiper-slide>
					</swiper>

					<!-- 커스텀 네비게이션 버튼 추가 -->
					<button type="button" class="new_brand_prev" @click="handleNewBrandNavigation('prev')">이전</button>
					<button type="button" class="new_brand_next" @click="handleNewBrandNavigation('next')">다음</button>
				</div>

				<div class="new_brand_paging"></div>
			</div>
			<!-- //신규 브랜드 -->

			<!-- 중앙 배너 -->
			<div class="banner_center" v-if="adBanners.length > 0">
				<a href="#" @click.prevent="handleLinkClickAD(adBanners[0])" rel="noopener noreferrer">
					<picture>
						<source media="(max-width: 1023px)" :srcset="makeBannerImageUrl(adBanners[0].bannerPathMo || adBanners[0].bannerPath)" />
						<img :src="makeBannerImageUrl(adBanners[0].bannerPath)" :alt="adBanners[0].bannerTitle || '광고 배너'"
							loading="lazy" @error="handleBannerBrandImageError" />
					</picture>
				</a>
			</div>
			<!-- //중앙 배너 -->

			<!-- 분야별 -->
			<div>
				<div class="category_nav">
					<div class="category-item icon1" @click="handleCategoryClick(1, 'SERVICE_SHOPPING')">
						<span>쇼핑·생활</span>
					</div>
					<div class="category-item icon2" @click="handleCategoryClick(2, 'SERVICE_DINNER')">
						<span>외식·레스토랑</span>
					</div>
					<div class="category-item icon3" @click="handleCategoryClick(3, 'SERVICE_BAKE')">
						<span>커피·제빵</span>
					</div>
					<div class="category-item icon4" @click="handleCategoryClick(4, 'SERVICE_BEAUTY')">
						<span>패션·뷰티</span>
					</div>
					<div class="category-item icon5" @click="handleCategoryClick(5, 'SERVICE_BOOK')">
						<span>도서·교육</span>
					</div>
					<div class="category-item icon6" @click="handleCategoryClick(6, 'SERVICE_CULTURE')">
						<span>문화·헬스</span>
					</div>
					<div class="category-item icon7" @click="handleCategoryClick(7, 'SERVICE_TRIP')">
						<span>여행·숙박·교통</span>
					</div>
					<div class="category-item icon8" @click="handleCategoryClick(8, 'SERVICE_KIDS')">
						<span>유아·체험</span>
					</div>
				</div>

				<swiper :modules="modules" :space-between="20" class="category_swiper_cont" :loop="true" :autoplay="{
					delay: 12000,
					disableOnInteraction: false,
				}" :pagination="{
					el: '.category_paging',
					clickable: true,
					type: 'fraction',
				}" :navigation="{
					nextEl: '.category_next',
					prevEl: '.category_prev',
				}" :breakpoints="c_swiperBreakpoints" @swiper="onSwiperInit">
					<!-- 1. 쇼핑·생활 (SERVICE_SHOPPING) -->
					<swiper-slide>
						<h2 class="title_main">쇼핑·생활</h2>

						<a href="#" @click.prevent="
							handleLinkClick(getCategoryMainBanner('SERVICE_SHOPPING'))
							" rel="noopener noreferrer" v-if="getCategoryMainBanner('SERVICE_SHOPPING')">
							<img :src="makeBannerImageUrl(
								getCategoryMainBanner('SERVICE_SHOPPING').bannerPath
							)
								" alt="쇼핑·생활" @error="handleBannerBrandImageError" loading="lazy" />
						</a>


						<!-- 서브 배너들 -->
						<div class="banner_category_area">
							<template v-for="(item, index) in getCategorySubBanners('SERVICE_SHOPPING')" :key="index">
								<a href="#" @click.prevent="handleCategoryBannerClick(item)" rel="noopener noreferrer">
									<img :src="makeBannerImageUrl(item.bannerPath)" alt=""
										@error="handleBannerBrandImageError" loading="lazy" />
								</a>
							</template>

							<!-- 서브 배너가 3개 미만이면 기본 이미지로 채움 -->
							<RouterLink v-for="i in Math.max(
								0,
								3 - getCategorySubBanners('SERVICE_SHOPPING').length
							)" :key="`default-${i}`" to="/">

							</RouterLink>
						</div>
					</swiper-slide>

					<!-- 2. 외식·레스토랑 (SERVICE_DINNER) -->
					<swiper-slide>
						<h2 class="title_main">외식·레스토랑</h2>

						<a href="#" @click.prevent="
							handleLinkClick(getCategoryMainBanner('SERVICE_DINNER'))
							" rel="noopener noreferrer" v-if="getCategoryMainBanner('SERVICE_DINNER')">
							<img :src="makeBannerImageUrl(
								getCategoryMainBanner('SERVICE_DINNER').bannerPath
							)
								" alt="외식·레스토랑" @error="handleBannerBrandImageError" loading="lazy" />
						</a>

						<div class="banner_category_area">
							<template v-for="(item, index) in getCategorySubBanners('SERVICE_DINNER')" :key="index">
								<a href="#" @click.prevent="handleCategoryBannerClick(item)" rel="noopener noreferrer">
									<img :src="makeBannerImageUrl(item.bannerPath)" alt=""
										@error="handleBannerBrandImageError" loading="lazy" />
								</a>
							</template>
						</div>
					</swiper-slide>

					<!-- 3. 커피·제빵 (SERVICE_BAKE) -->
					<swiper-slide>
						<h2 class="title_main">커피·제빵</h2>

						<a href="#" @click.prevent="
							handleLinkClick(getCategoryMainBanner('SERVICE_BAKE'))
							" rel="noopener noreferrer" v-if="getCategoryMainBanner('SERVICE_BAKE')">
							<img :src="makeBannerImageUrl(
								getCategoryMainBanner('SERVICE_BAKE').bannerPath
							)
								" alt="커피·제빵" @error="handleBannerBrandImageError" loading="lazy" />
						</a>
						<RouterLink to="/" v-else>
							<img src="@/assets/images/main/banner_shopping.jpg" alt="커피·제빵" loading="lazy" />
						</RouterLink>

						<div class="banner_category_area">
							<template v-for="(item, index) in getCategorySubBanners('SERVICE_BAKE')" :key="index">
								<a href="#" @click.prevent="handleCategoryBannerClick(item)" rel="noopener noreferrer">
									<img :src="makeBannerImageUrl(item.bannerPath)" alt=""
										@error="handleBannerBrandImageError" loading="lazy" />
								</a>
							</template>

							<RouterLink v-for="i in Math.max(
								0,
								3 - getCategorySubBanners('SERVICE_BAKE').length
							)" :key="`default-${i}`" to="/">
								<img src="@/assets/images/main/banner_category1.jpg" alt="" loading="lazy" />
							</RouterLink>
						</div>
					</swiper-slide>

					<!-- 4. 패션·뷰티 (SERVICE_BEAUTY) -->
					<swiper-slide>
						<h2 class="title_main">패션·뷰티</h2>

						<a href="#" @click.prevent="
							handleLinkClick(getCategoryMainBanner('SERVICE_BEAUTY'))
							" rel="noopener noreferrer" v-if="getCategoryMainBanner('SERVICE_BEAUTY')">
							<img :src="makeBannerImageUrl(
								getCategoryMainBanner('SERVICE_BEAUTY').bannerPath
							)
								" alt="패션·뷰티" @error="handleBannerBrandImageError" loading="lazy" />
						</a>
						<RouterLink to="/" v-else>
							<img src="@/assets/images/main/banner_restaurant.jpg" alt="패션·뷰티" loading="lazy" />
						</RouterLink>

						<div class="banner_category_area">
							<template v-for="(item, index) in getCategorySubBanners('SERVICE_BEAUTY')" :key="index">
								<a href="#" @click.prevent="handleCategoryBannerClick(item)" rel="noopener noreferrer">
									<img :src="makeBannerImageUrl(item.bannerPath)" alt=""
										@error="handleBannerBrandImageError" loading="lazy" />
								</a>
							</template>

							<RouterLink v-for="i in Math.max(
								0,
								3 - getCategorySubBanners('SERVICE_BEAUTY').length
							)" :key="`default-${i}`" to="/">
								<img src="@/assets/images/main/banner_category1.jpg" alt="" loading="lazy" />
							</RouterLink>
						</div>
					</swiper-slide>

					<!-- 5. 도서·교육 (SERVICE_BOOK) -->
					<swiper-slide>
						<h2 class="title_main">도서·교육</h2>

						<a href="#" @click.prevent="
							handleLinkClick(getCategoryMainBanner('SERVICE_BOOK'))
							" rel="noopener noreferrer" v-if="getCategoryMainBanner('SERVICE_BOOK')">
							<img :src="makeBannerImageUrl(
								getCategoryMainBanner('SERVICE_BOOK').bannerPath
							)
								" alt="도서·교육" @error="handleBannerBrandImageError" loading="lazy" />
						</a>
						<RouterLink to="/" v-else>
							<img src="@/assets/images/main/banner_shopping.jpg" alt="도서·교육" loading="lazy" />
						</RouterLink>

						<div class="banner_category_area">
							<template v-for="(item, index) in getCategorySubBanners('SERVICE_BOOK')" :key="index">
								<a href="#" @click.prevent="handleCategoryBannerClick(item)" rel="noopener noreferrer">
									<img :src="makeBannerImageUrl(item.bannerPath)" alt=""
										@error="handleBannerBrandImageError" loading="lazy" />
								</a>
							</template>

							<RouterLink v-for="i in Math.max(
								0,
								3 - getCategorySubBanners('SERVICE_BOOK').length
							)" :key="`default-${i}`" to="/">
								<img src="@/assets/images/main/banner_category1.jpg" alt="" loading="lazy" />
							</RouterLink>
						</div>
					</swiper-slide>

					<!-- 6. 문화·헬스 (SERVICE_CULTURE) -->
					<swiper-slide>
						<h2 class="title_main">문화·헬스</h2>

						<a href="#" @click.prevent="
							handleLinkClick(getCategoryMainBanner('SERVICE_CULTURE'))
							" rel="noopener noreferrer" v-if="getCategoryMainBanner('SERVICE_CULTURE')">
							<img :src="makeBannerImageUrl(
								getCategoryMainBanner('SERVICE_CULTURE').bannerPath
							)
								" alt="문화·헬스" @error="handleBannerBrandImageError" loading="lazy" />
						</a>
						<RouterLink to="/" v-else>
							<img src="@/assets/images/main/banner_restaurant.jpg" alt="문화·헬스" loading="lazy" />
						</RouterLink>

						<div class="banner_category_area">
							<template v-for="(item, index) in getCategorySubBanners('SERVICE_CULTURE')" :key="index">
								<a href="#" @click.prevent="handleCategoryBannerClick(item)" rel="noopener noreferrer">
									<img :src="makeBannerImageUrl(item.bannerPath)" alt=""
										@error="handleBannerBrandImageError" loading="lazy" />
								</a>
							</template>

							<RouterLink v-for="i in Math.max(
								0,
								3 - getCategorySubBanners('SERVICE_CULTURE').length
							)" :key="`default-${i}`" to="/">
								<img src="@/assets/images/main/banner_category1.jpg" alt="" loading="lazy" />
							</RouterLink>
						</div>
					</swiper-slide>

					<!-- 7. 여행·숙박·교통 (SERVICE_TRIP) -->
					<swiper-slide>
						<h2 class="title_main">여행·숙박·교통</h2>

						<a href="#" @click.prevent="
							handleLinkClick(getCategoryMainBanner('SERVICE_TRIP'))
							" rel="noopener noreferrer" v-if="getCategoryMainBanner('SERVICE_TRIP')">
							<img :src="makeBannerImageUrl(
								getCategoryMainBanner('SERVICE_TRIP').bannerPath
							)
								" alt="여행·숙박·교통" @error="handleBannerBrandImageError" loading="lazy" />
						</a>
						<RouterLink to="/" v-else>
							<img src="@/assets/images/main/banner_shopping.jpg" alt="여행·숙박·교통" loading="lazy" />
						</RouterLink>

						<div class="banner_category_area">
							<template v-for="(item, index) in getCategorySubBanners('SERVICE_TRIP')" :key="index">
								<a href="#" @click.prevent="handleCategoryBannerClick(item)" rel="noopener noreferrer">
									<img :src="makeBannerImageUrl(item.bannerPath)" alt=""
										@error="handleBannerBrandImageError" loading="lazy" />
								</a>
							</template>

							<RouterLink v-for="i in Math.max(
								0,
								3 - getCategorySubBanners('SERVICE_TRIP').length
							)" :key="`default-${i}`" to="/">
								<img src="@/assets/images/main/banner_category1.jpg" alt="" loading="lazy" />
							</RouterLink>
						</div>
					</swiper-slide>

					<!-- 8. 유아·체험 (SERVICE_KIDS) -->
					<swiper-slide>
						<h2 class="title_main">유아·체험</h2>

						<a href="#" @click.prevent="
							handleLinkClick(getCategoryMainBanner('SERVICE_KIDS'))
							" rel="noopener noreferrer" v-if="getCategoryMainBanner('SERVICE_KIDS')">
							<img :src="makeBannerImageUrl(
								getCategoryMainBanner('SERVICE_KIDS').bannerPath
							)
								" alt="유아·체험" @error="handleBannerBrandImageError" loading="lazy" />
						</a>
						<RouterLink to="/" v-else>
							<img src="@/assets/images/main/banner_restaurant.jpg" alt="유아·체험" loading="lazy" />
						</RouterLink>

						<div class="banner_category_area">
							<template v-for="(item, index) in getCategorySubBanners('SERVICE_KIDS')" :key="index">
								<a href="#" @click.prevent="handleLinkClick(item)" rel="noopener noreferrer">
									<img :src="makeBannerImageUrl(item.bannerPath)" alt=""
										@error="handleBannerBrandImageError" loading="lazy" />
								</a>
							</template>

							<RouterLink v-for="i in Math.max(
								0,
								3 - getCategorySubBanners('SERVICE_KIDS').length
							)" :key="`default-${i}`" to="/">
								<img src="@/assets/images/main/banner_category1.jpg" alt="" loading="lazy" />
							</RouterLink>
						</div>
					</swiper-slide>
				</swiper>

				<div class="category_btn_area">
					<button type="button" class="category_prev" @click="handleCustomNavigation('prev')">이전</button>
					<div class="category_paging"></div>
					<button type="button" class="category_next" @click="handleCustomNavigation('next')">다음</button>
				</div>
			</div>
			<!-- //분야별 -->

			<!-- 주목해야 할 브랜드 (모바일 그리드 레이아웃을 PC에도 적용) -->
			<div class="attend_brand_area">
				<h2 class="title_main">주목해야 할 브랜드</h2>

				<div class="attend_swiper">
					<!-- 모바일 그리드 레이아웃을 데스크톱에도 동일하게 적용 -->
					<div class="mobile-brand-grid">
						<!-- API에서 가져온 브랜드 목록 전체 표시 -->
						<a v-for="(brand, index) in attendBrands" :key="index" href="#"
							@click.prevent="openBrandPopupFromAttend(brand)" class="mobile-brand-item">
							<img :src="brand.logoUrl" :alt="brand.brandName" @error="handleBranndImageError" loading="lazy" />
							<span class="mobile-brand-name">{{ brand.brandName }}</span>
						</a>
					</div>
				</div>
			</div>

			<div v-if="isNarasarangOrigin" class="hanasarang-info"
				style="margin-top: 20px; padding:22px 24px 22px 36px; border-radius:12px; background-color:#fff9f5; border:1px solid #ee7528; box-shadow:0 4px 12px rgba(0,0,0,0.06); box-sizing:border-box; color:#333; font-size:15px;">
				<ul style="list-style:none; padding-left:0; margin:0;">
					<li style="margin-bottom:12px; font-size:15px; line-height:1.9; color:#2f2f2f; font-weight:700;">·
						하나 나라사랑카드(체크)
						손님 대상 혜택입니다.</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.2; color:#2f2f2f;">· 군 급여 이체 조건 및 전월 실적
						조건이 필요하지 않은
						이벤트입니다.</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.2; color:#2f2f2f;">· 제휴사의 상황에 따라 혜택이 변동될
						수 있으므로 이벤트
						페이지를 통해 혜택을 반드시 확인하시기 바랍니다.</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.2; color:#2f2f2f;">· 본 이벤트는 하나카드 및 제휴사의
						사정에 따라 사전 예고
						없이 변경되거나 중단될 수 있습니다.</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.2; color:#2f2f2f;">· 본 혜택은 하나나라사랑카드 이용 시
						적용되며 행사대상,
						품목 등 행사 세부사항은 이벤트 안내 홈페이지에서 확인하시기 바랍니다</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.2; color:#2f2f2f;">· 결제 취소 또는 변경 시 할인
						적용이 불가할 수 있으니
						이점 유의하시기 바랍니다.(기존 거래 건 취소 후 재승인, 부분취소, 주문 상품 품절로 인한 취소 또는 변경 등)</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.2; color:#2f2f2f;">· 간편결제수단 이용 시 청구할인혜택을
						받으실 수 없습니다.
					</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.2; color:#2f2f2f;">· 나라사랑카드 청구할인혜택은
						캐시백으로 진행되며, 2영업일
						뒤에 고객의 결제계좌로 입금 됩니다. 단 매출 취소 시 할인 적용된 이외 금액만 환불됩니다.</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.2; color:#2f2f2f;">· 하나머니 결제 시, 하나
						나라라사랑카드(체크)로 결제한 부분만 할인이
						적용됩니다.</li>
					<li style="margin-bottom:8px; font-size:15px; line-height:1.2; color:#2f2f2f;">· 계약체결 전 상품설명서 및
						상품약관을 반드시 확인하시기
						바랍니다.</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.22; color:#2f2f2f; font-weight:bold;">·
						신용카드 발급이
						부적정한
						경우(개인신용평점 낮음 등)
						카드발급이 제한될 수 있습니다.</li>
					<li style="margin-bottom:1px; font-size:15px; line-height:1.2; color:#2f2f2f; font-weight:bold;">·
						카드이용대금과 이에
						수반되는 모든
						수수료를 지정된
						대금결제일에 상환하여야 합니다.</li>
					<li style="margin-bottom:8px; font-size:15px; line-height:1.2; color:#2f2f2f; font-weight:bold;">·
						금융소비자는 해당 상품
						또는
						서비스에 대하여 설명을 받을
						권리가 있습니다.</li>
				</ul>
				<p class="hanasarang-note"
					style="margin-top:20px; font-size:13px; line-height:1.75; color:#5b5b5b; padding-left:0;">
					· 상환능력에 비해 신용카드 사용액이 과도할 경우, 귀하의 개인신용평점이 하락할 수 있습니다.<br />
					· 개인신용평점 하락 시 금융거래와 관련된 불이익이 발생할 수 있습니다.<br />
					· 일정기간 원리금을 연체할 경우, 모든 원리금을 변제할 의무가 발생할 수 있습니다.<br />
					(하나카드 준법심의 A-26-0080 (2026.01.13 ~ 2026.12.31))
				</p>
			</div>

			<AlertPopup v-model="showLoginAlert" title="알림" class="alert_popup">
				<template #layer_content>
					<div class="alert-content">
						<p>{{ loginAlertMessage }}</p>
						<div class="alert-buttons">
							<button class="btn btn-primary" @click="handleLoginAlertConfirm">확인</button>
							<button class="btn btn-secondary" @click="handleLoginAlertCancel">취소</button>
						</div>
					</div>
				</template>
			</AlertPopup>

			<div v-if="showPopup" class="popup-overlay">
				<div v-for="(item, index) in images" :key="index" class="popup-content">
					<button @click="closePopup(index)" class="close-btn">&times;</button>
					<img :src="item" alt="Popup Image" loading="lazy" />
				</div>
			</div>

			<!-- 브랜드 상세 팝업 추가 -->
			<div v-if="showBrandPopup" class="brand_popup_overlay" @click="closeBrandPopup">
				<div class="brand_popup_container" @click.stop>
					<div class="popup_header">
						<h3>브랜드 상세정보</h3>
						<button class="close_btn" @click="closeBrandPopup">×</button>
					</div>
					<div class="popup_content">
						<!-- BI_002 컴포넌트 직접 로드 -->
						<BrandDetail v-if="selectedBrandData" :brandUuid="selectedBrandData.brandUuid"
							:hideListButton="true" :isModal="true" />
					</div>
				</div>
			</div>
		</div> <!-- cont_center 닫는 태그 -->
	</div> <!-- main-page 닫는 태그 -->


</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation, Pagination, EffectCreative } from "swiper/modules";
import { ref, watch, onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import { getBranchUuid } from "@/lib/Config";
import { getAxios, postAxios, getAxiosCustom } from "@/lib/AxiosCall";
import {
	DEFAULT_BANNER_HERO_MO_IMAGE,
	DEFAULT_BANNER_HERO_PC_IMAGE,
	DEFAULT_BANNER_MAIN_IMAGE,
	DEFAULT_NO_IMAGE,
	LOCAL_STORAGE_HVM_USERINFO // 추가
} from "@/lib/Constant";
import MainPopup from "@/components/MainPopup.vue";
import AlertPopup from "@/components/AlertPopup.vue"; // AlertPopup 추가
import MobileBanner from "@/components/MobileBanner.vue"; // MobileBanner 추가
import defaultBrandImage from "@/assets/images/main/brand_round1.jpg";
import narasarangLogo from "@/assets/images/main/narasarang.jpg";
import { getHotSearchBanners } from "@/lib/SearchService";
import { emitter } from '@/lib/eventBus';
import BrandDetail from '@/pages/HFO_BI_002.vue';
import { SessionManager } from "@/lib/SessionManager";
import { currentProfile } from "@/lib/Seo";

export default {
	components: {
		Swiper,
		SwiperSlide,
		MainPopup,
		AlertPopup, // AlertPopup 컴포넌트 추가
		MobileBanner, // MobileBanner 컴포넌트 추가
		BrandDetail
	},
	data() {
		return {
			popupImages: [],
			modules: [Navigation, Pagination, Autoplay, EffectCreative],
			mainSwiper: null,
			isOpen: false,
			visual_swiperBreakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 0,
					loop: true,
				},
				1024: {
					slidesPerView: "auto",
					spaceBetween: 0, // creative 효과 사용 시 간격은 translate로 제어하므로 0으로 설정
					centeredSlides: true,
					loop: true,
				},
			},
			swiperBreakpoints: {
				320: {
					slidesPerView: 2,
					spaceBetween: 9,
					slidesPerGroup: 2,
					loop: true,
					centeredSlides: false
				},
				768: {
					slidesPerView: 2.5,
					spaceBetween: 12,
					slidesPerGroup: 2,
					loop: true,
					centeredSlides: false
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 20,
					slidesPerGroup: 4,
					loop: true
				},
			},
			thumb_swiperBreakpoints: {
				320: {
					slidesPerView: 4,
					slidesPerGroup: 8,
					spaceBetween: 0,
					loop: true,
					allowTouchMove: false,
				},
				768: {
					slidesPerView: 4,
					slidesPerGroup: 8,
					spaceBetween: 0,
					loop: true,
					allowTouchMove: false,
				},
				1024: {
					slidesPerView: "auto",
					spaceBetween: "auto",
				},
			},
			c_swiperBreakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 0,
					slidesPerGroup: 1,
					loop: true,
					loopFillGroupWithBlank: true,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 20,
					slidesPerGroup: 2,
					loop: true,
					loopFillGroupWithBlank: true,
				},
			},
			isMobile: false,
			isUltraWide: false,
			isEdgeBrowser: false,
			currentZoomScale: 1,
			isSamsungHost: false,
			isNarasarangOrigin: false,
			narasarangLogo,
			attendBrands: [],
			// AlertPopup 관련 데이터 추가
			showLoginAlert: false,
			loginAlertMessage: '',

			// 브랜드 팝업 관련 데이터
			showBrandPopup: false,
			selectedBrandData: null,

			// 신규브랜드 Swiper 인스턴스
			newBrandSwiper: null,

			// 모바일 배너 관련 데이터
			showMobileBanner: false,
			mobileBanners: [],
			currentMobileBannerIndex: 0,

			// 광고 배너 클릭 시 로그인 대기용
			pendingAdBanner: null
		};
	},

	setup() {
		const router = useRouter();
		const branchUuid = ref(getBranchUuid());

		// 각 배너 타입별 ref
		const heroBanners = ref([]);
		const newBanners = ref([]);
		const adBanners = ref([]);
		const categoryBanners = ref([]);
		const searchBanners = ref([]);

		const swiperInstances = ref([]);

		// 배열 셔플 함수 (Fisher-Yates 알고리즘)
		const shuffleArray = (array) => {
			const shuffled = [...array];
			for (let i = shuffled.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
			}
			return shuffled;
		};

		// useQuery 대신 새로운 함수로 대체
		const fetchBannerData = async () => {
			try {
				console.log("배너 데이터 로딩 시작...");
				const response = await getAxiosCustom("/hvm/v1/branch/banner", {
					//branchUuid: branchUuid.value,
				});

				console.log("배너 데이터 응답:", response);

				if (response && response.data && response.data.page) {
					const list = response.data.page.list || [];

					// 배너 타입별 분류
					const sortedHeroList = list
						.filter((b) => b.bannerType === "BANNER_HERO")
						.sort((a, b) => parseInt(a.order) - parseInt(b.order));

					// 기존 복제 로직 대신 아래로 교체
					if (sortedHeroList.length < 2) {
						heroBanners.value = sortedHeroList;
					} else {
						// 1. 배열 두 번 복제
						const doubled = sortedHeroList.concat(sortedHeroList);
						// 2. 마지막 요소를 꺼내서 앞에 붙여주기
						const last = doubled.pop();
						doubled.unshift(last);
						heroBanners.value = doubled;
					}

					newBanners.value = list
						.filter((b) => b.bannerType === "BANNER_NEW")
						.sort((a, b) => parseInt(a.order) - parseInt(b.order));

					adBanners.value = list
						.filter((b) => b.bannerType === "BANNER_AD")
						.sort((a, b) => parseInt(a.order) - parseInt(b.order));

					categoryBanners.value = list
						.filter((b) => b.bannerType === "BANNER_CATEGORY")
						.sort((a, b) => parseInt(a.order) - parseInt(b.order));

					// BANNER_SEARCH 타입 필터링
					const searchBannerItems = list.filter(
						(b) => b.bannerType === "BANNER_SEARCH"
					);

					// HOT 항목과 일반 항목 분리
					const hotItems = searchBannerItems.filter(
						(item) => item.hotFlag === "Y"
					);
					const normalItems = searchBannerItems.filter(
						(item) => item.hotFlag !== "Y"
					);

					// HOT 항목만 셔플
					const shuffledHotItems = shuffleArray(hotItems);

					// 두 배열 다시 합치기 (HOT 항목이 먼저 나오도록)
					const combinedItems = [...shuffledHotItems, ...normalItems];

					// 최대 5개로 제한
					searchBanners.value = combinedItems.slice(0, 5);

					sessionStorage.setItem(
						"hvm_searchBanners",
						JSON.stringify(combinedItems.slice(0, 5))
					);
					emitter.emit('update-hot-keywords');

					console.log("셔플된 HOT 검색어:", shuffledHotItems);
					console.log("최종 검색어 배너 데이터:", searchBanners.value);

					// 데이터 로드 완료 후 Swiper 업데이트
					nextTick(() => {
						if (swiperInstances.value.length > 0) {
							swiperInstances.value.forEach((swiper) => {
								if (swiper) {
									swiper.update();

									// 메인 비주얼 영역 처리
									if (
										swiper.el &&
										swiper.el.closest(".main_visual_area") &&
										heroBanners.value.length > 1
									) {
										swiper.slideToLoop(1, 0);
										console.log(
											"데이터 로드 후 메인 비주얼 2번째 슬라이드로 이동"
										);
									}

									// 신규브랜드 영역 처리 - 첫 번째 슬라이드로 이동
									if (
										swiper.el &&
										swiper.el.closest(".new_brand_swiper")
									) {
										setTimeout(() => {
											if (swiper.params.loop && swiper.slides.length > 1) {
												swiper.slideToLoop(0, 0);
											} else {
												swiper.slideTo(0, 0);
											}
											if (swiper.pagination) {
												swiper.pagination.update();
											}
											console.log("데이터 로드 후 신규브랜드 첫 번째 슬라이드로 이동");
										}, 200);
									}

									// autoplay 시작
									if (swiper.autoplay) {
										setTimeout(() => {
											swiper.autoplay.start();
										}, 1000);
									}
								}
							});
						}

						// 추가적으로 newBrandSwiper도 업데이트
						setTimeout(() => {
							const instance = this;
							if (instance && instance.updateAllSwipers) {
								instance.updateAllSwipers();
							}
						}, 500);
					});
				} else {
					console.error("API 응답 형식이 올바르지 않습니다:", response);
				}
			} catch (error) {
				console.error("배너 데이터 로드 실패:", error);
			}
		};

		// 컴포넌트 마운트 시 데이터 로딩
		onMounted(() => {
			fetchBannerData();
		});

		return {
			heroBanners,
			newBanners,
			adBanners,
			categoryBanners,
			searchBanners,
			router,
			swiperInstances,
			fetchBannerData,
		};
	},
	created() {
		// 로그인 팝업 관리용 인스턴스 변수 (Vue 반응성 제외)
		this._currentPopup = null;
		this._popupId = null;

		this.fetchPopupImages();
		this.fetchAttendBrands();
		this.fetchMobileBanners(); // 모바일 배너 로드 추가

		// 데이터 로드 후 Swiper 업데이트
		this.$nextTick(() => {
			setTimeout(() => {
				this.updateAllSwipers();
			}, 1000);
		});
	},
	mounted() {
		this.isEdgeBrowser = /Edg\//.test(window.navigator.userAgent || '');
		this.checkWindow();
		window.addEventListener("resize", this.checkWindow);
		if (window.visualViewport && window.visualViewport.addEventListener) {
			window.visualViewport.addEventListener('resize', this.checkWindow);
		}

		// 데이터 로드 후 Swiper 업데이트를 위해 약간의 지연 후 실행
		this.$nextTick(() => {
			setTimeout(() => {
				this.updateAllSwipers();
			}, 500);
		});

		// host 체크: samsung.hivitamin.co.kr이면 category_nav 아래 컨텐츠 숨김
		try {
			const origin = window.location.origin;
			this.isNarasarangOrigin = origin === 'https://narasarang.hivitamin.co.kr';
			if (origin === 'https://samsung.hivitamin.co.kr') {
				this.isSamsungHost = true;
				console.log('HFO_MA_001: samsung host detected, hiding content after category_nav');
			}
		} catch (e) {
			// 서버사이드 렌더링 또는 access 불가 환경 대비
			console.warn('HFO_MA_001: host detection failed', e);
		}

		// 모바일 배너 데이터 로드를 기다린 후 자동 트리거 확인
		// 800ms 충분히 기다려서 fetchMobileBanners가 완료되도록 함
		setTimeout(() => {
			console.log('HFO_MA_001: mounted 타이밍에 checkAutoTriggerBanner 호출');
			this.checkAutoTriggerBanner();
		}, 1200); // fetchMobileBanners 완료 대기
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkWindow);
		if (window.visualViewport && window.visualViewport.removeEventListener) {
			window.visualViewport.removeEventListener('resize', this.checkWindow);
		}
	},
	computed: {
		showBenefitGuide() {
			return Boolean(currentProfile().benefitGuide);
		},
		heroSwiperKey() {
			return `${this.visualEffect}_${this.isEdgeZoomFallback ? 'edgeZoom' : 'normal'}`;
		},
		isEdgeZoomFallback() {
			return this.isEdgeBrowser && Math.abs((this.currentZoomScale || 1) - 1) > 0.001;
		},
		heroVisualBreakpoints() {
			if (this.isEdgeZoomFallback) {
				return {
					320: {
						slidesPerView: 1,
						spaceBetween: 0,
						loop: true,
						centeredSlides: false,
					},
					1024: {
						slidesPerView: 1,
						spaceBetween: 0,
						loop: true,
						centeredSlides: false,
					},
				};
			}
			return this.visual_swiperBreakpoints;
		},
		visualEffect() {
			if (this.isEdgeZoomFallback) {
				return 'slide';
			}
			return this.isUltraWide ? 'slide' : 'creative';
		}
	},
	methods: {
		// 중앙 배너 클릭 처리 메서드 수정
		handleLinkClickAD(banner) {
			console.log("HFO_MA_001: 중앙 배너 클릭됨", banner);

			// linkType이 LINK_NEW인 경우에만 특별 처리
			// if (banner.linkType !== 'LINK_NEW') {
			// 	console.log("HFO_MA_001: LINK_NEW가 아님, 기본 처리");
			// 	this.handleDefaultBannerClick(banner);
			// 	return;
			// }

			// localStorage에서 사용자 정보 확인
			const userInfoString = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);

			if (!userInfoString) {
				console.log("HFO_MA_001: 로그인 정보 없음 - AlertPopup 표시");
				// AlertPopup 표시 (확인 시 로그인 팝업 오픈)
				this.pendingAdBanner = banner; // 배너 정보 저장
				sessionStorage.setItem('pendingAdBanner', JSON.stringify(banner));
				this.showLoginRequiredAlert();
				return;
			}

			try {
				const userInfo = JSON.parse(userInfoString);
				const userUuid = userInfo.userUuid;

				if (!userUuid) {
					console.log("HFO_MA_001: userUuid 없음 - AlertPopup 표시");
					// AlertPopup 표시 (확인 시 로그인 팝업 오픈)
					this.pendingAdBanner = banner;
					sessionStorage.setItem('pendingAdBanner', JSON.stringify(banner));
					this.showLoginRequiredAlert();
					return;
				}

				if (banner.linkType === 'LINK_SELF' && banner.brandUuid) {
					sessionStorage.setItem("brandUuid", banner.brandUuid);
					this.$router.push({ name: 'HFO_BI_002', params: { brandUuid: banner.brandUuid } });
					return;
				}

				// URL에 userUuid 파라미터 추가하여 이동
				const targetUrl = this.addUserUuidToUrl(banner.linkUrl, userUuid);

				console.log("HFO_MA_001: userUuid 포함하여 배너 링크 이동", {
					원본URL: banner.linkUrl,
					최종URL: targetUrl,
					userUuid: userUuid
				});

				// 새 창에서 열기
				window.open(targetUrl, '_blank');

			} catch (error) {
				console.error("HFO_MA_001: 사용자 정보 파싱 실패", error);
				// 파싱 실패 시 AlertPopup 표시
				this.pendingAdBanner = banner;
				sessionStorage.setItem('pendingAdBanner', JSON.stringify(banner));
				this.showLoginRequiredAlert();
			}
		},

		// 로그인 완료 후 광고 배너를 userUuid 포함하여 오픈
		openAdBannerWithUser(banner) {
			try {
				const infoStr = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);
				if (!infoStr) return;
				const info = JSON.parse(infoStr);
				const userUuid = info && info.userUuid;
				if (!userUuid) return;
				const targetUrl = this.addUserUuidToUrl(banner.linkUrl, userUuid);
				window.open(targetUrl, '_blank');
			} catch (e) {
				console.warn('openAdBannerWithUser 실패', e);
			}
		},

		// 로그인 필요 AlertPopup 표시
		showLoginRequiredAlert() {
			console.log("App.vue: showLoginRequiredAlert 호출됨");

			this.loginAlertMessage = '로그인이 필요한 서비스입니다.\n로그인 페이지로 이동하시겠습니까?';
			this.showLoginAlert = true;

			console.log("App.vue: AlertPopup 설정 완료", {
				showLoginAlert: this.showLoginAlert,
				loginAlertMessage: this.loginAlertMessage
			});
		},

		// AlertPopup 확인 버튼 클릭 핸들러
		handleLoginAlertConfirm() {
			console.log("HFO_MA_001: AlertPopup 확인 - 로그인 팝업 오픈");
			this.showLoginAlert = false;
			// 로그인 팝업 오픈
			this.openLoginPopup(() => {
				console.log("HFO_MA_001: 로그인 완료");

				const pendingBanner = sessionStorage.getItem('pendingAdBanner');
				const banner = pendingBanner ? JSON.parse(pendingBanner) : this.pendingAdBanner;

				// 로그인 후 저장된 배너 이동 처리
				if (banner) {
					this.pendingAdBanner = null;
					sessionStorage.removeItem('pendingAdBanner');
					const userInfoString = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);
					const userInfo = userInfoString ? JSON.parse(userInfoString) : null;

					if (banner.linkType === 'LINK_SELF' && banner.brandUuid) {
						sessionStorage.setItem("brandUuid", banner.brandUuid);
						this.$router.push({ name: 'HFO_BI_002', params: { brandUuid: banner.brandUuid } });
						return;
					}

					const targetUrl = this.addUserUuidToUrl(banner.linkUrl, userInfo?.userUuid);

					// 같은 페이지 내 링크인지 확인
					const isInternalLink = targetUrl && (
						targetUrl.startsWith('/') ||
						targetUrl.startsWith(window.location.origin) ||
						targetUrl.startsWith(window.location.hostname)
					);

					if (isInternalLink) {
						// 내부 페이지 이동 - 자동으로 이동
						let pathToNavigate = targetUrl;

						// 전체 URL인 경우 경로만 추출
						if (targetUrl.includes('://')) {
							try {
								const url = new URL(targetUrl);
								pathToNavigate = url.pathname + url.search + url.hash;
							} catch (e) {
								console.warn("URL 파싱 실패", e);
								return;
							}
						}

						console.log("HFO_MA_001: 내부 페이지로 이동", pathToNavigate);
						this.$router.push(pathToNavigate);
					} else if (targetUrl) {
						console.log("HFO_MA_001: 로그인 후 외부 페이지로 이동", targetUrl);
						window.location.href = targetUrl;
					}
				}
			});
		},

		handleLoginAlertCancel() {
			console.log("HFO_MA_001: AlertPopup 취소 버튼 클릭됨");
			this.showLoginAlert = false;
			this.pendingAdBanner = null; // 저장된 배너 정보 초기화
			sessionStorage.removeItem('pendingAdBanner');
		},

		// 기본 배너 클릭 처리 (LINK_NEW가 아닌 경우)
		handleDefaultBannerClick(banner) {
			console.log("HFO_MA_001: 기본 배너 클릭 처리", banner);

			if (!banner.linkUrl) {
				console.warn("HFO_MA_001: 배너 링크 URL이 없습니다");
				return;
			}

			// linkType에 따른 처리
			switch (banner.linkType) {
				case 'LINK_SELF':
					// 같은 창에서 이동
					window.location.href = banner.linkUrl;
					break;
				case 'LINK_BLANK':
				default:
					// 새 창에서 열기
					window.open(banner.linkUrl, '_blank');
					break;
			}
		},

		// URL에 userUuid 파라미터 추가하는 헬퍼 메서드
		addUserUuidToUrl(url, userUuid) {
			if (!url || !userUuid) {
				return url;
			}

			try {
				const urlObj = new URL(url);
				urlObj.searchParams.set('userUuid', userUuid);
				return urlObj.toString();
			} catch (error) {
				// URL 파싱 실패 시 쿼리스트링 방식으로 추가
				console.warn("HFO_MA_001: URL 파싱 실패, 쿼리스트링 방식으로 추가", error);

				const separator = url.includes('?') ? '&' : '?';
				return `${url}${separator}userUuid=${encodeURIComponent(userUuid)}`;
			}
		},

		makeBannerImageUrl(imagePath) {
			return imagePath
				? process.env.VUE_APP_IMAGE_BASE_URL + "images/" + imagePath
				: DEFAULT_NO_IMAGE;
		},

		handleBannerHeroPcImageError(event) {
			console.log("히어로 배너 이미지 로드 실패");
			this.dropPictureSources(event.target);
			event.target.src = DEFAULT_NO_IMAGE;
		},

		// <picture> 안의 img 가 실패했을 때는 <source> 가 남아 있으면 src 를 바꿔도 적용되지 않으므로 source 를 제거한다
		dropPictureSources(img) {
			const picture = img && img.parentElement;
			if (picture && picture.tagName === "PICTURE") {
				picture.querySelectorAll("source").forEach((el) => el.remove());
			}
		},

		handleBannerHeroMoImageError(event) {
			console.log("히어로 모바일 배너 이미지 로드 실패");
			event.target.src = DEFAULT_NO_IMAGE;
		},

		handleBannerBrandImageError(event) {
			this.dropPictureSources(event.target);
			event.target.src = DEFAULT_BANNER_MAIN_IMAGE;
		},

		async fetchPopupImages() {
			try {
				const response = await getAxiosCustom("/hvm/v1/promotion/popup", {
					//branchUuid: getBranchUuid(),
				});

				console.log("팝업 데이터 응답:", response);

				if (response && response.data && response.data.page) {
					// POPUP_LAYER 타입만 필터링하는 조건 추가
					this.popupImages = response.data.page.list
						.filter((item) => item.popupDispType === "POPUP_LAYER")
						.map((item) => ({
							src: process.env.VUE_APP_IMAGE_BASE_URL + "images/" + item.path,
							link: item.linkUrl,
							linkType: item.linkType,
							order: item.dispOrder,
							brandUuid: item.brandUuid,
						}));

					// 순서에 따라 정렬
					this.popupImages.sort(
						(a, b) => parseInt(a.order) - parseInt(b.order)
					);

					console.log("처리된 POPUP_LAYER 이미지:", this.popupImages);
				} else {
					console.error("API 응답 형식이 올바르지 않습니다:", response);
				}
			} catch (error) {
				console.error("팝업 이미지 조회 중 오류 발생:", error);
			}
		},

		// 주목해야 할 브랜드 데이터 가져오기
		async fetchAttendBrands() {
			try {
				const response = await getAxiosCustom("/hvm/v1/branch/brand/new", {
					//branchUuid: getBranchUuid(),
				});

				if (response && response.data && response.data.page) {
					this.attendBrands = response.data.page.list.map((brand) => ({
						...brand,
						logoUrl: brand.logoPath
							? process.env.VUE_APP_IMAGE_BASE_URL + "images/" + brand.logoPath
							: defaultBrandImage,
					}));

					console.log("주목해야 할 브랜드 로딩 완료:", this.attendBrands);
				} else {
					console.error("브랜드 API 응답 형식이 올바르지 않습니다:", response);
				}
			} catch (error) {
				console.error("주목해야 할 브랜드 데이터 로드 실패:", error);
			}
		},

		// 모바일 배너 데이터 로드
		async fetchMobileBanners() {
			try {
				const response = await getAxios("/hvm/v1/branch/banner", {
					popupDispType: "POPUP_MOBILE"
				});

				// getAxios 는 응답 본문을 바로 돌려주므로 response.page 가 실제 구조다 (response.data 는 과거 axios 원본 형태 호환)
				const mobilePage = (response && response.page) || (response && response.data && response.data.page);
				if (mobilePage && mobilePage.list) {
					this.mobileBanners = mobilePage.list
						.filter((item) => item.popupDispType === "POPUP_MOBILE")
						.map((item) => ({
							id: item.bannerId,
							imgPathMo: process.env.VUE_APP_IMAGE_BASE_URL + "images/" + item.path,
							linkUrl: item.linkUrl,
							linkType: item.linkType,
							order: item.dispOrder,
							brandUuid: item.brandUuid,
						}));

					// 순서에 따라 정렬
					this.mobileBanners.sort(
						(a, b) => parseInt(a.order) - parseInt(b.order)
					);

					console.log("처리된 POPUP_MOBILE 이미지:", this.mobileBanners);
				} else {
					console.error("모바일 배너 API 응답 형식이 올바르지 않습니다:", response);
				}
			} catch (error) {
				console.error("모바일 배너 조회 중 오류 발생:", error);
			}
		},

		toggleOpen() {
			this.isOpen = !this.isOpen;
		},

		// URL 파라미터에서 자동 배너 클릭/팝업 확인
		checkAutoTriggerBanner() {
			// URL 정보 출력 (디버깅용)
			console.log('HFO_MA_001: checkAutoTriggerBanner 시작');
			console.log('  - window.location.href:', window.location.href);
			console.log('  - window.location.search:', window.location.search);

			const urlParams = new URLSearchParams(window.location.search);
			const triggerType = urlParams.get('trigger'); // 'banner' 또는 'popup'
			const bannerUrl = urlParams.get('banner-url');
			const popupType = urlParams.get('popup-type'); // 'layer' 또는 'mobile'
			const requireLogin = urlParams.get('require-login') === 'true';

			console.log('HFO_MA_001: 자동 트리거 파라미터 확인:', {
				triggerType,
				bannerUrl,
				popupType,
				requireLogin
			});

			if (!triggerType) {
				console.log('HFO_MA_001: trigger 파라미터 없음 - 자동 트리거 무시');
				return; // 파라미터가 없으면 종료
			}

			// 배너 클릭 자동 실행
			if (triggerType === 'banner' && bannerUrl) {
				setTimeout(() => {
					const banner = {
						linkUrl: decodeURIComponent(bannerUrl),
						linkType: requireLogin ? 'LINK_NEW' : 'LINK_EXTERNAL'
					};
					console.log('HFO_MA_001: 자동 배너 클릭 실행:', banner);
					this.handleLinkClickAD(banner);
				}, 800); // 페이지 로드 완료 대기
			}

			// 팝업 자동 표시
			if (triggerType === 'popup' && popupType) {
				console.log('HFO_MA_001: 팝업 트리거 감지 - popupType:', popupType);
				setTimeout(() => {
					if (popupType === 'layer' && this.popupImages.length > 0) {
						// 레이어 팝업은 MainPopup 컴포넌트에서 자동으로 표시됨
						console.log('HFO_MA_001: 레이어 팝업 자동 표시됨');
					} else if (popupType === 'mobile') {
						// 모바일 하단 팝업 자동 표시
						console.log('HFO_MA_001: 모바일 팝업 체크 - mobileBanners.length:', this.mobileBanners.length);
						if (this.mobileBanners.length > 0) {
							this.showMobileBanner = true;
							console.log('HFO_MA_001: 모바일 팝업 자동 표시 실행 완료');
						} else {
							console.warn('HFO_MA_001: 모바일 팝업 데이터 없음');
						}
					}
				}, 800);

				// URL의 ? 앞 부분을 추출하여 배너로 변환
				// 예: https://www.jinair.com/booking/index?trigger=popup&popup-type=mobile
				// → https://www.jinair.com/booking/index를 배너 링크로 사용
				const fullUrl = window.location.href;
				const questionMarkIndex = fullUrl.indexOf('?');

				if (questionMarkIndex > -1) {
					const baseUrl = fullUrl.substring(0, questionMarkIndex);
					console.log('HFO_MA_001: 추출된 기본 URL:', baseUrl);

					// 팝업 표시 후 일정 시간 뒤에 배너 링크 이동
					setTimeout(() => {
						const banner = {
							linkUrl: baseUrl,
							linkType: 'LINK_EXTERNAL'
						};
						console.log('HFO_MA_001: 팝업 URL 자동 이동 실행:', banner);
						this.handleLinkClickAD(banner);
					}, 2000); // 팝업 표시 후 2초 뒤 이동
				} else {
					console.warn('HFO_MA_001: URL에 쿼리 파라미터가 없습니다 - trigger 파라미터를 통해 진입했지만 URL 형식 오류');
				}
			}
		},		// 모바일 배너 클릭 처리
		handleMainPopupClick(image) {
			console.log('HFO_MA_001: MainPopup 클릭:', image);
			// image 데이터를 banner 형식으로 변환
			const banner = {
				linkUrl: image.link,
				linkType: image.linkType || 'LINK_EXTERNAL',
				brandUuid: image.brandUuid,
			};
			this.handleLinkClickAD(banner);
		},

		handleMobileBannerClick(banner) {
			console.log('HFO_MA_001: 모바일 배너 클릭:', banner);
			this.handleLinkClickAD(banner);
			this.showMobileBanner = false;
		},

		// 모바일 배너 "오늘 하루 보지 않기" 처리
		handleMobileBannerNotToday() {
			const futureDate = new Date();
			futureDate.setHours(23, 59, 59, 999);
			sessionStorage.setItem('hideMobileBannerUntil', futureDate.toISOString());
			this.showMobileBanner = false;
			console.log('HFO_MA_001: 모바일 배너 오늘 하루 숨김 처리됨');
		},

		checkWindow() {
			const wasMobile = this.isMobile;
			const wasUltraWide = this.isUltraWide;
			const wasEdgeZoomFallback = this.isEdgeZoomFallback;
			const zoomScale = window.visualViewport && window.visualViewport.scale
				? window.visualViewport.scale
				: 1;
			const normalizedWidth = Math.round(window.innerWidth * zoomScale);
			this.currentZoomScale = zoomScale;

			this.isMobile = window.innerWidth <= 1023; // CSS breakpoint와 일치시키기 (1023px 이하는 모바일)
			this.isUltraWide = normalizedWidth >= 1920;

			// 모바일/데스크톱 전환 시 Swiper 업데이트
			if (wasMobile !== this.isMobile || wasUltraWide !== this.isUltraWide || wasEdgeZoomFallback !== this.isEdgeZoomFallback) {
				console.log('화면 크기 변경됨:', wasMobile ? '모바일→데스크톱' : '데스크톱→모바일');

				this.$nextTick(() => {
					setTimeout(() => {
						this.updateAllSwipers();
					}, 300);
				});
			}
		},

		onSwiperInit(swiper) {
			if (!swiper) return;

			// Swiper 인스턴스 저장 (추적을 위한 배열이 없다면 추가)
			if (!this.swiperInstances) this.swiperInstances = [];

			// 완전히 파괴된(destroyed) 인스턴스는 제거하고 현재 인스턴스 추가
			this.swiperInstances = this.swiperInstances.filter(s => s && !s.destroyed && s.el);
			this.swiperInstances.push(swiper);

			// 각 swiper 타입별로 loop 설정 확인 및 강제 활성화
			setTimeout(() => {
				if (swiper.el && !swiper.destroyed) {
					const swiperType = swiper.el.classList.contains('category_swiper_cont') ? '분야별' :
						swiper.el.closest('.attend_swiper') ? '주목해야 할 브랜드' :
							swiper.el.closest('.new_brand_swiper') ? '신규 브랜드' :
								swiper.el.closest('.main_visual_area') ? '메인 비주얼' : '기타';

					console.log(`${swiperType} swiper 초기화:`, {
						slides: swiper.slides.length,
						realIndex: swiper.realIndex,
						activeIndex: swiper.activeIndex,
						isEnd: swiper.isEnd,
						isBeginning: swiper.isBeginning,
						loop: swiper.params.loop
					});

					// loop가 활성화되어 있는지 확인하고 강제 활성화
					if (swiper.params.loop && swiper.slides.length > 1) {
						// loop 재초기화
						swiper.loopDestroy();
						swiper.loopCreate();
						swiper.loopFix();

						// navigation 업데이트
						if (swiper.navigation) {
							swiper.navigation.update();
						}

						// 신규 브랜드 swiper의 경우 추가 처리
						if (swiperType === '신규 브랜드') {
							// 네비게이션 버튼 강제 활성화
							const prevBtn = swiper.el.querySelector('.swiper-button-prev');
							const nextBtn = swiper.el.querySelector('.swiper-button-next');

							if (prevBtn) prevBtn.classList.remove('swiper-button-disabled');
							if (nextBtn) nextBtn.classList.remove('swiper-button-disabled');

							// 한 번 더 업데이트
							setTimeout(() => {
								swiper.update();
								if (swiper.navigation) {
									swiper.navigation.update();
								}
							}, 50);
						}

						console.log(`${swiperType} swiper loop 재초기화 완료`);
					}

					// If this swiper is the main visual, store reference for per-slide controls
					if (swiper.el && swiper.el.closest('.main_visual_area')) {
						this.mainSwiper = swiper;
					}
				}
			}, 100);
		},

		// 커스텀 네비게이션 핸들러 추가
		handleCustomNavigation(direction) {
			// 분야별 swiper 인스턴스 찾기
			const categorySwiper = this.swiperInstances.find(swiper =>
				swiper.el && swiper.el.classList.contains('category_swiper_cont')
			);

			if (!categorySwiper) {
				console.warn('분야별 swiper 인스턴스를 찾을 수 없습니다');
				return;
			}

			console.log('커스텀 네비게이션:', direction, {
				realIndex: categorySwiper.realIndex,
				activeIndex: categorySwiper.activeIndex,
				slidesLength: categorySwiper.slides.length,
				isEnd: categorySwiper.isEnd,
				isBeginning: categorySwiper.isBeginning
			});

			if (direction === 'next') {
				if (categorySwiper.isEnd) {
					// 마지막 슬라이드에서 첫 번째로 이동
					categorySwiper.slideTo(0);
				} else {
					categorySwiper.slideNext();
				}
			} else if (direction === 'prev') {
				if (categorySwiper.isBeginning) {
					// 첫 번째 슬라이드에서 마지막으로 이동
					categorySwiper.slideTo(categorySwiper.slides.length - 1);
				} else {
					categorySwiper.slidePrev();
				}
			}
		},

		// 신규브랜드 Swiper 초기화
		onNewBrandSwiperInit(swiper) {
			if (!swiper) return;

			console.log('신규브랜드 Swiper 초기화:', swiper);

			// 신규브랜드 swiper 인스턴스 저장
			this.newBrandSwiper = swiper;

			// 즉시 업데이트하여 페이지네이션이 제대로 작동하도록 함
			this.$nextTick(() => {
				if (!swiper || swiper.destroyed) return;
				swiper.update();

				// 페이지네이션 강제 업데이트
				if (swiper.pagination) {
					if (typeof swiper.pagination.init === 'function') swiper.pagination.init();
					if (typeof swiper.pagination.render === 'function') swiper.pagination.render();
					if (typeof swiper.pagination.update === 'function') swiper.pagination.update();
				}

				// 루프 모드 재초기화
				if (swiper.params.loop && swiper.slides.length > 1) {
					swiper.loopDestroy();
					swiper.loopCreate();
					swiper.loopFix();
				}

				// 첫 번째 슬라이드로 이동 (loop 모드에서 올바른 인덱스 사용)
				setTimeout(() => {
					if (!swiper || swiper.destroyed) return;
					if (swiper.params.loop && swiper.slides.length > 1) {
						// loop 모드에서는 실제 첫 번째 슬라이드로 이동
						swiper.slideToLoop(0, 0);
					} else {
						swiper.slideTo(0, 0);
					}

					// 페이지네이션 다시 업데이트
					if (swiper.pagination && typeof swiper.pagination.update === 'function') {
						swiper.pagination.update();
					}

					console.log('첫 번째 슬라이드로 이동 완료:', {
						realIndex: swiper.realIndex,
						activeIndex: swiper.activeIndex
					});
				}, 100);

				// 모바일에서 추가 초기화 로직
				if (this.isMobile) {
					setTimeout(() => {
						if (!swiper || swiper.destroyed) return;
						swiper.update();
						if (swiper.pagination) {
							if (typeof swiper.pagination.destroy === 'function') swiper.pagination.destroy();
							if (typeof swiper.pagination.init === 'function') swiper.pagination.init();
							if (typeof swiper.pagination.render === 'function') swiper.pagination.render();
							if (typeof swiper.pagination.update === 'function') swiper.pagination.update();
						}

						// 다시 첫 번째 슬라이드로 이동
						if (swiper.params.loop && swiper.slides.length > 1) {
							swiper.slideToLoop(0, 0);
						} else {
							swiper.slideTo(0, 0);
						}

						console.log('모바일 신규브랜드 Swiper 추가 업데이트 완료');
					}, 300);
				}

				console.log('신규브랜드 Swiper 업데이트 완료:', {
					realIndex: swiper.realIndex,
					activeIndex: swiper.activeIndex,
					slidesLength: swiper.slides.length,
					pagination: !!swiper.pagination,
					isMobile: this.isMobile
				});
			});

			// 기존 onSwiperInit 호출
			this.onSwiperInit(swiper);
		},

		// 신규브랜드 슬라이드 변경 시 호출
		onNewBrandSlideChange(swiper) {
			if (!swiper || swiper.destroyed) return;
			console.log('신규브랜드 슬라이드 변경:', {
				realIndex: swiper.realIndex,
				activeIndex: swiper.activeIndex
			});

			// 페이지네이션 업데이트
			if (swiper.pagination && typeof swiper.pagination.update === 'function') {
				swiper.pagination.update();
			}
		},

		// 신규브랜드 전환 완료 시 호출 (모바일에서 페이지네이션 문제 해결용)
		onNewBrandTransitionEnd(swiper) {
			if (this.isMobile && swiper && !swiper.destroyed && swiper.pagination && typeof swiper.pagination.update === 'function') {
				setTimeout(() => {
					if (!swiper || swiper.destroyed || !swiper.pagination || typeof swiper.pagination.update !== 'function') return;
					swiper.pagination.update();
				}, 50);
			}
		},

		// 신규브랜드 네비게이션 핸들러
		handleNewBrandNavigation(direction) {
			if (!this.newBrandSwiper) {
				console.warn('신규브랜드 swiper 인스턴스를 찾을 수 없습니다');
				return;
			}

			console.log('신규브랜드 네비게이션:', direction, {
				realIndex: this.newBrandSwiper.realIndex,
				activeIndex: this.newBrandSwiper.activeIndex,
				slidesLength: this.newBrandSwiper.slides.length,
				isEnd: this.newBrandSwiper.isEnd,
				isBeginning: this.newBrandSwiper.isBeginning,
				loop: this.newBrandSwiper.params.loop
			});

			if (direction === 'next') {
				this.newBrandSwiper.slideNext();
			} else if (direction === 'prev') {
				this.newBrandSwiper.slidePrev();
			}
		},

		// 모든 Swiper 인스턴스 업데이트
		updateAllSwipers() {
			console.log('모든 Swiper 업데이트 시작');

			// 신규브랜드 Swiper 업데이트
			if (this.newBrandSwiper && !this.newBrandSwiper.destroyed) {
				console.log('신규브랜드 Swiper 업데이트');
				this.newBrandSwiper.update();

				if (this.newBrandSwiper.pagination) {
					if (typeof this.newBrandSwiper.pagination.init === 'function') this.newBrandSwiper.pagination.init();
					if (typeof this.newBrandSwiper.pagination.render === 'function') this.newBrandSwiper.pagination.render();
					if (typeof this.newBrandSwiper.pagination.update === 'function') this.newBrandSwiper.pagination.update();
				}

				// 루프 모드 재초기화
				if (this.newBrandSwiper.params.loop && this.newBrandSwiper.slides.length > 1) {
					this.newBrandSwiper.loopDestroy();
					this.newBrandSwiper.loopCreate();
					this.newBrandSwiper.loopFix();
				}

				// 첫 번째 슬라이드로 이동
				setTimeout(() => {
					if (!this.newBrandSwiper || this.newBrandSwiper.destroyed) return;
					if (this.newBrandSwiper.params.loop && this.newBrandSwiper.slides.length > 1) {
						this.newBrandSwiper.slideToLoop(0, 0);
					} else {
						this.newBrandSwiper.slideTo(0, 0);
					}

					if (this.newBrandSwiper.pagination && typeof this.newBrandSwiper.pagination.update === 'function') {
						this.newBrandSwiper.pagination.update();
					}
				}, 150);

				// 모바일에서 추가 처리
				if (this.isMobile) {
					setTimeout(() => {
						if (this.newBrandSwiper && !this.newBrandSwiper.destroyed && this.newBrandSwiper.pagination) {
							if (typeof this.newBrandSwiper.pagination.destroy === 'function') this.newBrandSwiper.pagination.destroy();
							if (typeof this.newBrandSwiper.pagination.init === 'function') this.newBrandSwiper.pagination.init();
							if (typeof this.newBrandSwiper.pagination.render === 'function') this.newBrandSwiper.pagination.render();
							if (typeof this.newBrandSwiper.pagination.update === 'function') this.newBrandSwiper.pagination.update();

							// 다시 첫 번째 슬라이드로 이동
							if (this.newBrandSwiper.params.loop && this.newBrandSwiper.slides.length > 1) {
								this.newBrandSwiper.slideToLoop(0, 0);
							} else {
								this.newBrandSwiper.slideTo(0, 0);
							}

							console.log('모바일 신규브랜드 페이지네이션 강제 업데이트 완료', {
								realIndex: this.newBrandSwiper.realIndex,
								totalSlides: this.newBrandSwiper.slides.length
							});
						}
					}, 200);
				}
			}

			// 다른 모든 swiper 인스턴스도 업데이트
			// 유효하지 않거나 파괴된 인스턴스 필터링
			if (this.swiperInstances) {
				this.swiperInstances = this.swiperInstances.filter(swiper => swiper && !swiper.destroyed && swiper.el);

				this.swiperInstances.forEach((swiper, index) => {
					try {
						if (swiper && !swiper.destroyed) {
							// console.log(`Swiper ${index} 업데이트`);
							swiper.update();

							if (swiper.pagination) {
								swiper.pagination.update();
							}

							if (swiper.navigation) {
								swiper.navigation.update();
							}
						}
					} catch (e) {
						console.warn(`Swiper ${index} 업데이트 실패:`, e);
					}
				});
			}

			console.log('모든 Swiper 업데이트 완료');
		},

		// 서비스 타입별 카테고리명 매핑
		getServiceTypeName(serviceType) {
			const serviceTypeMap = {
				SERVICE_SHOPPING: "쇼핑·생활",
				SERVICE_DINNER: "외식·레스토랑",
				SERVICE_BAKE: "커피·제빵",
				SERVICE_BEAUTY: "패션·뷰티",
				SERVICE_BOOK: "도서·교육",
				SERVICE_CULTURE: "문화·헬스",
				SERVICE_TRIP: "여행·숙박·교통",
				SERVICE_KIDS: "유아·체험",
			};
			return serviceTypeMap[serviceType] || serviceType;
		},

		// 카테고리명을 서비스 타입으로 변환
		getServiceTypeByName(name) {
			const reversedMap = {
				"쇼핑·생활": "SERVICE_SHOPPING",
				"외식·레스토랑": "SERVICE_DINNER",
				"커피·제빵": "SERVICE_BAKE",
				"패션·뷰티": "SERVICE_BEAUTY",
				"도서·교육": "SERVICE_BOOK",
				"문화·헬스": "SERVICE_CULTURE",
				"여행·숙박·교통": "SERVICE_TRIP",
				"유아·체험": "SERVICE_KIDS",
			};
			return reversedMap[name];
		},

		// 서비스 타입으로 메인 배너 가져오기 (cateMainFlag='Y')
		getCategoryMainBanner(serviceType) {
			// serviceType이 카테고리명인 경우 코드로 변환
			const serviceCode = this.getServiceTypeByName(serviceType) || serviceType;

			return this.categoryBanners.find(
				(banner) =>
					banner.brandServiceType === serviceCode && banner.cateMainFlag === "Y"
			);
		},

		// 서비스 타입으로 서브 배너 목록 가져오기 (cateMainFlag='N')
		getCategorySubBanners(serviceType, limit = 3) {
			// serviceType이 카테고리명인 경우 코드로 변환
			const serviceCode = this.getServiceTypeByName(serviceType) || serviceType;

			return this.categoryBanners
				.filter(
					(banner) =>
						banner.brandServiceType === serviceCode &&
						banner.cateMainFlag !== "Y"
				)
				.sort((a, b) => parseInt(a.order) - parseInt(b.order))
				.slice(0, limit);
		},

		// 카테고리별 기본 이미지 경로 반환
		getDefaultCategoryImage(serviceType) {
			const imageMap = {
				SERVICE_SHOPPING: "@/assets/images/main/banner_shopping.jpg",
				SERVICE_DINNER: "@/assets/images/main/banner_restaurant.jpg",
				SERVICE_BAKE: "@/assets/images/main/banner_shopping.jpg",
				SERVICE_BEAUTY: "@/assets/images/main/banner_restaurant.jpg",
				SERVICE_BOOK: "@/assets/images/main/banner_shopping.jpg",
				SERVICE_CULTURE: "@/assets/images/main/banner_restaurant.jpg",
				SERVICE_TRIP: "@/assets/images/main/banner_shopping.jpg",
				SERVICE_KIDS: "@/assets/images/main/banner_restaurant.jpg",
			};

			// serviceType이 카테고리명인 경우 코드로 변환
			const serviceCode = this.getServiceTypeByName(serviceType) || serviceCode;

			return (
				imageMap[serviceCode] || "@/assets/images/main/banner_shopping.jpg"
			);
		},

		makeLinkUrl(url) {
			if (!url) return "#";

			// 이미 http:// 또는 https://로 시작하면 그대로 반환
			if (url.startsWith("http://") || url.startsWith("https://")) {
				return url;
			}

			// 그 외에는 http:// 추가
			return `http://${url}`;
		},

		handleLinkClick(item) {
			// 파라미터 확인
			if (!item) return;

			console.log("링크 클릭:", item.linkType, item.linkUrl);

			// 메인 비주얼에서 event 타입인 경우 또는 eventUuid가 있는 경우 이벤트 상세 페이지로 이동
			if (item && (item.type === 'event' || item.eventUuid)) {
				const eventUuid = item.eventUuid || sessionStorage.getItem('eventUuid');
				if (eventUuid) {
					console.log('HFO_MA_001: 이벤트 배너 클릭 - PR_003로 이동', eventUuid);
					sessionStorage.setItem('eventUuid', eventUuid);
					this.$router.push({ name: 'HFO_PR_003', params: { eventUuid } });
					return;
				}
			}

			// 링크 타입에 따라 처리
			if (item.linkType === "LINK_NEW") {
				// 새 창에서 열기
				window.open(this.makeLinkUrl(item.linkUrl), "_blank");
			} else {
				// 브랜드 페이지로 이동 (params 사용하여 URL에 brandUuid 포함)
				sessionStorage.setItem("brandUuid", item.brandUuid);
				this.$router.push({ name: 'HFO_BI_002', params: { brandUuid: item.brandUuid } });
			}
		},

		/**
		 * 카테고리 아이콘 클릭 시 브랜드 리스트 페이지로 이동하면서 해당 탭 선택
		 * @param {Number} index 카테고리 인덱스 (0부터 시작)
		 * @param {String} serviceType 서비스 타입 코드 (예: 'SERVICE_SHOPPING')
		 */
		handleCategoryClick(index, serviceType) {
			// 이벤트 버블링 방지
			if (event) event.stopPropagation();

			// 세션 스토리지에 선택된 탭 인덱스 저장
			sessionStorage.setItem("selectedCategoryTab", index);
			sessionStorage.setItem("selectedServiceType", serviceType);

			// 해시 기반 네비게이션으로 변경 (라우터 대신)
			this.$router.push("/HFO_BI_001");
		},

		/**
		 * 카테고리 배너(banner_category_area)에서 서브 배너 클릭 시
		 * 카테고리를 "전체"로 초기화하고 배너 링크 처리
		 * @param {Object} banner 배너 객체
		 */
		handleCategoryBannerClick(banner) {
			console.log("카테고리 서브 배너 클릭:", banner);

			// 카테고리를 "전체"로 초기화
			sessionStorage.setItem("selectedCategoryTab", "0");
			sessionStorage.setItem("selectedServiceType", "");

			// 기존 배너 클릭 처리 수행
			this.handleLinkClick(banner);
		},

		// 검색어 배너 클릭 시 브랜드 상세 페이지로 이동
		navigateToSearchBrand(banner) {
			if (banner && banner.brandUuid) {
				console.log("검색어 배너 클릭:", banner.bannerTitle, "브랜드 UUID:", banner.brandUuid);

				// 브랜드 UUID를 세션 스토리지에 저장
				sessionStorage.setItem("brandUuid", banner.brandUuid);

				// 브랜드 상세 페이지로 이동
				this.$router.push({ name: 'HFO_BI_002', params: { brandUuid: banner.brandUuid } });
			} else {
				console.warn("브랜드 UUID가 없는 검색어 배너:", banner);
			}
		},

		// 신규 브랜드 배너 클릭 시 팝업 열기
		openBrandPopup(banner) {
			console.log("신규 브랜드 배너 클릭:", banner);

			if (banner.brandUuid) {
				this.selectedBrandData = {
					brandUuid: banner.brandUuid,
					bannerTitle: banner.bannerTitle
				};
				this.showBrandPopup = true;

				// brandUuid를 세션에 저장 (BI_002에서 사용)
				sessionStorage.setItem("brandUuid", banner.brandUuid);

				// 스크롤 방지
				document.body.style.overflow = 'hidden';
			} else {
				console.warn("브랜드 UUID가 없는 배너:", banner);
				// 기존 방식으로 처리
				this.handleLinkClick(banner);
			}
		},

		// 주목해야 할 브랜드 클릭 시 팝업 열기
		openBrandPopupFromAttend(brand) {
			console.log("주목해야 할 브랜드 클릭:", brand);

			if (brand.brandUuid) {
				this.selectedBrandData = {
					brandUuid: brand.brandUuid,
					brandName: brand.brandName
				};
				this.showBrandPopup = true;

				// brandUuid를 세션에 저장
				sessionStorage.setItem("brandUuid", brand.brandUuid);

				// 스크롤 방지
				document.body.style.overflow = 'hidden';
			} else {
				console.warn("브랜드 UUID가 없는 브랜드:", brand);
			}
		},

		// 브랜드 팝업 닫기
		closeBrandPopup() {
			console.log("브랜드 팝업 닫기");
			this.showBrandPopup = false;
			this.selectedBrandData = null;

			// 스크롤 복원
			document.body.style.overflow = 'auto';
		},

		// per-slide navigation handlers (call stored mainSwiper)
		onHeroPrev() {
			if (this.mainSwiper) {
				this.mainSwiper.slidePrev();
			} else {
				console.warn('mainSwiper not initialized yet');
			}
		},

		onHeroNext() {
			if (this.mainSwiper) {
				this.mainSwiper.slideNext();
			} else {
				console.warn('mainSwiper not initialized yet');
			}
		},

		// 헤더와 동일한 방식의 로그인 팝업 오픈 (완료 콜백 지원)
		openLoginPopup(onCompleted) {
			try {
				const target = `${window.location.origin}/HFO_LO_001_POP`;
				const popupWidth = 380;
				const popupHeight = 560;
				const left = Math.floor((window.screen.width - popupWidth) / 2);
				const top = Math.floor((window.screen.height - popupHeight) / 2);

				const popupName = `hvm_login_${Date.now()}`;
				const popup = window.open(
					target,
					popupName,
					`width=${popupWidth},height=${popupHeight},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
				);
				if (!popup) {
					alert('팝업이 차단되었습니다. 팝업 허용 후 다시 시도하세요.');
					return;
				}

				this._currentPopup = popup;
				this._popupId = popupName;				// 화살표 함수로 변경하여 this 바인딩 유지
				const messageHandler = (e) => {
					try {
						const origin = String(e.origin || '');
						const allowed = origin === window.location.origin || origin.includes('localhost') || origin.includes('bridgem.hivitamin.co.kr');
						if (!allowed) return;
						const data = e.data || {};
						if (data.type === 'HVM_POPUP_CONTENT_SIZE') {
							const requestedWidth = parseInt(data.width, 10) || popupWidth;
							const requestedHeight = parseInt(data.height, 10) || popupHeight;
							const maxPopupWidth = Math.min(560, Math.max(420, (window.screen?.availWidth || window.innerWidth) - 24));
							const maxPopupHeight = Math.min(980, Math.max(560, (window.screen?.availHeight || window.innerHeight) - 24));
							const newWidth = Math.min(maxPopupWidth, Math.max(320, requestedWidth));
							const newHeight = Math.min(maxPopupHeight, Math.max(popupHeight, requestedHeight));

							if (this._currentPopup && !this._currentPopup.closed && typeof this._currentPopup.resizeTo === 'function') {
								try { this._currentPopup.resizeTo(newWidth, newHeight); } catch (_) { /* noop */ }
							}
							if (this._currentPopup && !this._currentPopup.closed && typeof this._currentPopup.moveTo === 'function') {
								const centerLeft = Math.floor((window.screen.width - newWidth) / 2);
								const centerTop = Math.floor((window.screen.height - newHeight) / 2);
								try { this._currentPopup.moveTo(centerLeft, centerTop); } catch (_) { /* noop */ }
							}
							return;
						}
						if (data.type === 'HVM_LOGIN_COMPLETED') {
							console.log('openLoginPopup: HVM_LOGIN_COMPLETED 수신');
							if (data.user) localStorage.setItem(LOCAL_STORAGE_HVM_USERINFO, JSON.stringify(data.user));
							if (data.token) sessionStorage.setItem('hvm_token', data.token);
							try { SessionManager.startSession(); } catch (e) { console.warn(e); }
							// 헤더/앱에 로그인 변경 알림
							emitter.emit('user-login-changed', { isLoggedIn: true, userInfo: data.user || null });

							// ACK 전송
							try {
								if (e.source && typeof e.source.postMessage === 'function') {
									e.source.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this._popupId }, e.origin);
								} else if (this._currentPopup && !this._currentPopup.closed) {
									this._currentPopup.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this._popupId }, e.origin);
								}
							} catch (ackErr) {
								console.warn('ACK failed', ackErr);
								try { if (this._currentPopup && !this._currentPopup.closed) this._currentPopup.postMessage({ type: 'HVM_POPUP_CLOSE_REQUEST', popupId: data.popupId || this._popupId }, e.origin); } catch (_) { /* noop */ }
							}

							setTimeout(() => {
								try { if (this._currentPopup && !this._currentPopup.closed) this._currentPopup.close(); } catch (_) { /* noop */ }
								this._currentPopup = null;
								this._popupId = null;
								window.removeEventListener('message', messageHandler);
								// 콜백을 별도의 setTimeout에서 실행하여 Vue 반응성과 분리
								setTimeout(() => {
									try { if (typeof onCompleted === 'function') onCompleted(); } catch (cbErr) { console.warn('onCompleted error', cbErr); }
								}, 0);
							}, 100);
						} else if (data.type === 'HVM_LOGIN_NEED_SIGNUP') {
							if (data.userData) sessionStorage.setItem('signup_user_data', JSON.stringify(data.userData));
							try {
								if (e.source && typeof e.source.postMessage === 'function') {
									e.source.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this._popupId }, e.origin);
								} else if (this._currentPopup && !this._currentPopup.closed) {
									this._currentPopup.postMessage({ type: 'HVM_LOGIN_ACK', popupId: data.popupId || this._popupId }, e.origin);
								}
							} catch (ackErr) {
								console.warn('ACK failed', ackErr);
								try { if (this._currentPopup && !this._currentPopup.closed) this._currentPopup.postMessage({ type: 'HVM_POPUP_CLOSE_REQUEST', popupId: data.popupId || this._popupId }, e.origin); } catch (_) { /* noop */ }
							}
							setTimeout(() => {
								try { if (this._currentPopup && !this._currentPopup.closed) this._currentPopup.close(); } catch (_) { /* noop */ }
								this._currentPopup = null;
								this._popupId = null;
								window.removeEventListener('message', messageHandler);
								const userData = data.userData || {};
								const isKakaoUser = (userData.USER_IN_TYPE || '') === 'USER_IN_KAKAO';
								this.$router.push(isKakaoUser ? '/HFO_MB_004_SNS' : '/HFO_MB_003');
							}, 100);
						} else if (data.type === 'HVM_POPUP_CLOSE_REQUEST') {
							try { if (this._currentPopup && !this._currentPopup.closed) this._currentPopup.close(); } catch (_) { /* noop */ }
							this._currentPopup = null;
							this._popupId = null;
							window.removeEventListener('message', messageHandler);
						}
					} catch (err) {
						console.warn('openLoginPopup messageHandler error', err);
					}
				};

				window.addEventListener('message', messageHandler, false);
				// 타임아웃 시 리스너 제거 및 상태 초기화
				setTimeout(() => {
					try { window.removeEventListener('message', messageHandler); } catch (_) { /* noop */ }
					this._currentPopup = null;
					this._popupId = null;
				}, 10 * 60 * 1000);
			} catch (err) {
				console.error('openLoginPopup error', err);
			}
		}
	}
}
</script>

<style scoped>
/* 카드사별 혜택 정리 플로팅 버튼: 상단 이동 버튼(App.vue .quick_menu2) 바로 위 */
.card_benefit_float {
	position: fixed;
	right: 30px;
	bottom: 92px;
	z-index: 9998;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 76px;
	height: 76px;
	border-radius: 50%;
	background: #f07f28;
	color: #fff;
	font-size: 12px;
	font-weight: 700;
	line-height: 1.3;
	text-align: center;
	text-decoration: none;
	word-break: keep-all;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.card_benefit_float:hover {
	background: #de6d20;
}

@media (max-width: 1023px) {
	.card_benefit_float {
		right: 20px;
		bottom: 72px;
		width: 62px;
		height: 62px;
		font-size: 11px;
	}
}

/* samsung 호스트일 때 category_nav 아래 모든 컨텐츠 숨김 */
.cont_center.samsung-hide .category_nav {
	display: none !important;
}

.cont_center.samsung-hide .category_nav+* {
	display: none !important;
}

/* 일부 구간은 형제 연속 선택자로 잡히지 않을 수 있으므로 아래와 같이 넓게 적용 */
.cont_center.samsung-hide .category_nav~* {
	display: none !important;
}

/* Per-slide hero image wrapper and buttons */
.hero-img-wrap {
	position: relative;
	display: block;
}

.hero-img-wrap>a {
	position: relative;
	display: block;
	z-index: 4;
	cursor: pointer;
}

/* 메인 비주얼: 좌측 슬라이드는 유지하면서, 전환을 부드럽고 고급스럽게 */
.main-visual-swiper .swiper-wrapper {
	transition-timing-function: cubic-bezier(0.22, 0.61, 0.36, 1);
}

.main-visual-swiper .swiper-slide {
	padding: 0 8px;
	box-sizing: border-box;
	opacity: 0.58;
	filter: saturate(0.85) brightness(0.92);
	transition: opacity 700ms ease, filter 1500ms ease;
	z-index: 1;
}

/*
	PC 고해상도/배율 환경에서 hit-test가 swiper-wrapper에 걸려
	히어로 링크 클릭이 무시되는 케이스를 방지한다.
*/
@media (min-width: 1024px) {
	.main-visual-swiper :deep(.swiper-wrapper) {
		pointer-events: none;
	}

	.main-visual-swiper :deep(.swiper-slide) {
		pointer-events: none;
	}

	.main-visual-swiper :deep(.swiper-slide-active),
	.main-visual-swiper :deep(.swiper-slide-active .hero-img-wrap),
	.main-visual-swiper :deep(.swiper-slide-active .hero-img-wrap > a),
	.main-visual-swiper :deep(.swiper-slide-active .hero-btn) {
		pointer-events: auto;
	}
}

.main-visual-swiper {
	--hero-slide-inline-gap: 8px;
	--hero-nav-offset-x: 0px;
	--hero-nav-offset-x-mobile: 0px;
	--hero-nav-vertical: 50%;
	overflow: visible;
	/* PC에서 좌우 슬라이드 보이도록 */
}

@media (max-width: 1023px) {
	.main-visual-swiper {
		overflow: hidden;
		/* 모바일에서는 넘치지 않도록 */
	}
}

@media (max-width: 768px) {
	.main-visual-swiper .swiper-slide {
		padding: 0 4px;
	}

	.main-visual-swiper {
		--hero-slide-inline-gap: 4px;
	}
}

.main-visual-swiper .swiper-slide img {
	transition: transform 900ms ease, filter 1500ms ease;
	transform: scale(1);
}

.main-visual-swiper .swiper-slide-active {
	opacity: 1;
	filter: saturate(1) brightness(1);
	z-index: 3;
}

.main-visual-swiper .swiper-slide-shadow-left,
.main-visual-swiper .swiper-slide-shadow-right,
.main-visual-swiper .swiper-slide-shadow-top,
.main-visual-swiper .swiper-slide-shadow-bottom {
	pointer-events: none !important;
}

.main-visual-swiper .swiper-slide-active img {
	transform: scale(1);
}

.main-visual-swiper .swiper-slide-prev,
.main-visual-swiper .swiper-slide-next {
	opacity: 0.8;
}

/* Default: hide per-slide buttons (only show on active slide)
   Swiper adds .swiper-slide-active to the currently centered slide */
.hero-btn {
	display: none;
	/* hidden by default */
	position: absolute;
	top: var(--hero-nav-vertical);
	transform: translateY(-50%);
	z-index: 20;
	min-width: 56px;
	height: 40px;
	padding: 0 12px;
	border-radius: 6px;
	/* slight rounding for a modern rectangular look */
	background: rgba(255, 255, 255, 0.95);
	color: #111;
	border: 1px solid rgba(0, 0, 0, 0.08);
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 20px;
	line-height: 1;
	cursor: pointer;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

/* show only for the active (centered) slide */
.swiper-slide-active:not(.swiper-slide-duplicate) .hero-btn {
	display: flex;

	/* match new_brand button visual: square layer with arrow sprite */
	width: 42px;
	min-width: 42px;
	height: 42px;
	padding: 0;
	background-color: rgba(0, 0, 0, 0.1);
	color: transparent;
	font-size: 0;
	line-height: 0;
	/* use sprite for arrow */
	border: none;
	border-radius: 0;
	box-shadow: none;
}

.swiper-slide-active:not(.swiper-slide-duplicate) .hero-btn::after {
	content: "";
	width: 13px;
	height: 25px;
	background: url("@/assets/images/main/arrow_slide.png") no-repeat center center;
	background-size: contain;
	display: block;
	margin: 0 auto;
	transform: none;
}

.swiper-slide-active:not(.swiper-slide-duplicate) .hero-next::after {
	transform: rotate(180deg);
}

/* Ensure neighboring slides (prev/next) and duplicate/cloned slides do not show buttons */
.swiper-slide-prev .hero-btn,
.swiper-slide-next .hero-btn,
.swiper-slide-duplicate .hero-btn {
	display: none !important;
}

/* In multi-column/multi-slide view (ultrawide), explicitly hide all hero-btn except the active one */
.swiper-slide .hero-btn {
	display: none !important;
}

.swiper-slide-active:not(.swiper-slide-duplicate) .hero-btn {
	display: flex !important;
}

/* Hide any legacy white navs that may be rendered inside slides (defensive) */
.swiper-slide .top_visual_prev,
.swiper-slide .top_visual_next {
	display: none !important;
}

.main-visual-swiper .hero-prev {
	left: var(--hero-nav-offset-x);
}

.main-visual-swiper .hero-next {
	right: var(--hero-nav-offset-x);
}

/* make tap target slightly larger on mobile */
@media (max-width: 768px) {
	.swiper-slide-active .hero-btn {
		width: 48px;
		min-width: 48px;
		height: 48px;
		font-size: 18px;
	}

	.main-visual-swiper .hero-prev {
		left: var(--hero-nav-offset-x-mobile);
	}

	.main-visual-swiper .hero-next {
		right: var(--hero-nav-offset-x-mobile);
	}
}

/* Hide legacy outer nav buttons to avoid duplicates */
.main_visual_area .top_visual_btn {
	display: none !important;
}

/* 주목해야 할 브랜드 섹션 하단 간격 확보 */
.attend_brand_area {
	margin-bottom: toRem(60);
	padding-bottom: toRem(8);
}

/* 바로 다음에 공시 블록이 오면 추가 간격 */
.attend_brand_area+.hanasarang-info {
	margin-top: toRem(40);
}

.hanasarang-info {
	/* 상단 여백을 더 늘리고 레이아웃 겹침 방지 */
	margin: toRem(120) toRem(20) toRem(60) !important;
	/* 내부 여백을 넉넉히 주어 텍스트가 좌측에 붙지 않도록 함 */
	padding: toRem(22) toRem(24) toRem(22) toRem(36) !important;
	border-radius: 12px;
	background-color: #fff9f5;
	border: 1px solid #ee7528;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
	clear: both;
	position: relative;
	box-sizing: border-box !important;
	color: #333 !important;
	font-size: toRem(15) !important;
}

.hanasarang-info ul {
	/* 불릿은 커스텀으로 유지, 내부 여백은 li에서 처리 */
	list-style: none;
	padding-left: 0;
	margin: 0;
}

.hanasarang-info li {
	position: relative !important;
	padding-left: toRem(28) !important;
	margin-bottom: toRem(10) !important;
	font-size: toRem(15) !important;
	line-height: 1.9 !important;
	color: #2f2f2f !important;
	hyphens: auto !important;
}

.hanasarang-info li::before {
	content: '';
	position: absolute;
	left: 0;
	top: calc(50% - 0.25rem);
	width: toRem(6);
	height: toRem(6);
	border-radius: 50%;
	background-color: #ee7528;
	/* 사이트 주황색으로 불릿 강조 */
}

.hanasarang-note {
	margin-top: toRem(20) !important;
	font-size: toRem(13) !important;
	line-height: 1.75 !important;
	color: #5b5b5b !important;
	padding-left: toRem(28) !important;
}

/* 모바일에서는 상단 간격을 조금 줄여서 뷰포트 활용 */
@media (max-width: 768px) {
	.hanasarang-info {
		margin: toRem(72) toRem(16) toRem(48);
		padding: toRem(16);
	}

	.hanasarang-info li {
		margin-bottom: toRem(10);
		line-height: 1.75;
	}
}

.narasarang-banner-wrapper {
	text-align: center;
	margin: toRem(20) 0;

	.narasarang-logo {
		max-width: 100%;
		height: auto;
		object-fit: contain;

		@media (max-width: 768px) {
			width: 100%;
			max-width: 100%;
		}
	}
}
</style>
